import settings from '@/settings';

export default function TextFeatured(props: {
  customSEOText?: {
    title: string;
    description: string;
  };
  customText: string;
}) {
  const { customSEOText, customText } = props;
  const richTextData =
    settings.store === 'reebelo-us'
      ? [
          customSEOText,
          {
            title: `Get the best price`,
            description: `Reebelo works together with several US-based buyback providers. We compare buyback prices between them and ensure that you get the highest buyback price offered in the United States for your Electronics across our partners.`,
          },
          {
            title: `We accept ${customText} in any condition`,
            description: `Our mission is to reduce e-waste by giving your device a second life. You can still sell your ${customText} with Reebelo even if the condition is not ideal. We take it in any condition, even if your ${customText} has a cracked screen, a swollen battery, or no charger. Sell your ${customText} with Reebelo today!`,
          },
          {
            title: `Buyback & Trade-In`,
            description: `In addition to selling your used Electronics or as new Electronics, you can also trade in used Electronics when buying a refurbished Electronics at Reebelo USA. After submitting your form above, simply let our operations team know that you want to trade in. Upgrade your Electronics today!`,
          },
        ]
      : [
          customSEOText,
          {
            title: `Get the best price`,
            description: `Reebelo works together with several ${settings.country} based buyback providers. We compare buyback prices between them and ensure that you get the highest buyback price offered in ${settings.country} for your ${customText} across our partners.`,
          },
          {
            title: `We accept ${customText} in any condition`,
            description: `Our mission is to reduce e-waste by giving your device a second life. You can still sell your ${customText} with Reebelo even if the condition is not ideal. We take it in any condition, even if your ${customText} has a cracked screen, a swollen battery, or no charger. Sell your ${customText} with Reebelo today!`,
          },
          {
            title: `Buyback & Trade-In`,
            description: `In addition to selling your used ${customText} or as new ${customText}, you can also trade in used ${customText} when buying a refurbished ${customText} at Reebelo ${settings.country}. After submitting your form above, simply let our operations team know that you want to trade in. Upgrade your ${customText} today!`,
          },
        ];

  return (
    <div className="mx-[-1rem] flex flex-wrap rounded">
      {(richTextData || []).map((item, index) => (
        <div
          key={index}
          className="mb-4 w-full px-4 last:mb-0 md:w-1/2 md:last:mb-4"
        >
          <h2 className="my-2 text-xl font-bold text-blue-500 md:mb-1 md:min-h-[64px] md:text-2xl lg:min-h-[0] ">
            {item?.title}
          </h2>
          <hr />
          <p className="my-4 text-base leading-relaxed text-gray-700">
            {item?.description}
          </p>
        </div>
      ))}
    </div>
  );
}
